import { createContext, useContext } from 'react'

export const ExitUrlContext = createContext<string | undefined>(undefined)

export const useExitUrlContext = () => useContext(ExitUrlContext) as string
